import React from "react";

export const InputDisabledContext = React.createContext(false);
